export type ServiceName = 'reserva' | 'enlace' | 'checkin' | 'pagos' | 'fianza' | 'accesos' | 'clima' | 'extras' | 'guia' | 'peticiones' | 'ayuda' | 'acompanantes' | 'notificaciones' | 'checkout'

const FLAGS: Record<ServiceName, string | undefined> = {
  reserva: import.meta.env.VITE_MOCK_RESERVA,
  enlace: import.meta.env.VITE_MOCK_ENLACE,
  checkin: import.meta.env.VITE_MOCK_CHECKIN,
  pagos: import.meta.env.VITE_MOCK_PAGOS,
  fianza: import.meta.env.VITE_MOCK_FIANZA,
  accesos: import.meta.env.VITE_MOCK_ACCESOS,
  clima: import.meta.env.VITE_MOCK_CLIMA,
  extras: import.meta.env.VITE_MOCK_EXTRAS,
  guia: import.meta.env.VITE_MOCK_GUIA,
  peticiones: import.meta.env.VITE_MOCK_PETICIONES,
  ayuda: import.meta.env.VITE_MOCK_AYUDA,
  acompanantes: import.meta.env.VITE_MOCK_ACOMPANANTES,
  notificaciones: import.meta.env.VITE_MOCK_NOTIFICACIONES,
  checkout: import.meta.env.VITE_MOCK_CHECKOUT,
}

/** true si `VITE_MOCK_<SERVICIO>=true` (CLAUDE.md). */
export function isMock(name: ServiceName): boolean {
  return FLAGS[name] === 'true'
}

/**
 * Capacidades sin endpoint que la implementación real delega en el mock (inventario D29). La banda
 * "Datos simulados" las nombra aunque el servicio corra contra la API real.
 */
export const MOCKED_CAPABILITIES: Partial<Record<ServiceName, string[]>> = {
  reserva: ['disponibilidad por día', 'política con fechas', 'personas', 'cambio de alojamiento', 'entrar antes', 'salir más tarde', 'petición a la propiedad'],
  peticiones: ['nueva petición', 'seguimiento de peticiones', 'comentarios y fotos'],
  extras: ['descripción y fotos', 'pago en la app', 'recibos', 'información práctica'],
  guia: ['cerca de ti'],
  ayuda: ['preguntas frecuentes', 'conversación', 'email'],
  checkout: ['lista de salida', 'ya hemos salido', 'desglose de cargos', 'reseña', 'descuento y fechas sugeridas', 'fidelización'],
  notificaciones: ['avisos enviados', 'preferencias de avisos', 'guardar datos', 'descarga y borrado de datos'],
  checkin: ['llegada', 'entrada anticipada', 'móvil', 'normas en 5 puntos', 'envío del contrato'],
  acompanantes: ['invitaciones (pospuesto)'],
  accesos: ['código del teclado', 'instrucciones con fotos', 'transporte y aparcamiento'],
  clima: ['preparar la llegada', 'atajos', 'automático', 'avisos del equipo', 'instrucciones con fotos'],
  pagos: ['desglose', 'tasa turística', 'cargos', 'recibos', 'datos fiscales', 'reenvío de recibos'],
  fianza: ['revisión', 'deducción', 'reclamación'],
}

/** Servicios de la lista que corren contra mock, total ("checkin") o en parte ("checkin (llegada, …)"). */
export function mockedServices(names: ServiceName[]): string[] {
  return names.flatMap((name) => {
    if (isMock(name)) return [name]
    const caps = MOCKED_CAPABILITIES[name]
    return caps ? [`${name} (${caps.join(', ')})`] : []
  })
}
